import styled from "styled-components/macro";

export const HelpText = styled.div(
  ({ theme }) => `
  font-size: ${theme.fontSizes.beta}px;
  text-align: center;  
  width: 100%;
`,
);
